import { Component, Input } from '@angular/core';
import { UICallHistoryItem } from '../../../models/company-call-history/company-call-history.model';
import { UtilsService } from '../../../services';

@Component({
  selector: 'voicemail',
  templateUrl: './voicemail.component.html',
  styleUrls: ['./voicemail.component.scss']
})
export class VoicemailComponent {
  @Input() callItem: UICallHistoryItem;

  constructor(
    private utilsService: UtilsService
  ) {}

  public openLink(link: string) {
    this.utilsService.openExternalLink(link);
  }
}
